{
  "version": 1,
  "asset_id": "1062662b-97c6-44a0-8b6d-9199d045f40e",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/1062662b-97c6-44a0-8b6d-9199d045f40e/sleeve-ugi-reflux-post-736.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/1062662b-97c6-44a0-8b6d-9199d045f40e/sleeve-ugi-reflux-post-736.jpg",
  "original_filename": "sleeve-ugi-reflux-post-736.jpg",
  "size": 69392,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T16:38:34Z"
}
